
import { FactcheckSuggestion } from "@/types";
import { Component, Vue } from "vue-property-decorator";
import * as FactcheckRequestServices from "@/services/FactCheckRequestServices";
import { intervalToDuration } from "date-fns";

@Component({
    components: {
        FlowFunnel: () => import("@/components/charts/requests/Funnel.vue"),
    }
})
export default class RequestsStats extends Vue {
    requests: FactcheckSuggestion[] = [];

    async getRequests() {
        this.requests = await FactcheckRequestServices.GetRequests();
    }

    percentageOfRequestsWithFactcheck = null as number | null;
    requestsWithFactcheck = 0;
    averageResponseTimeMs = null as number | null;
    averageResponseTimeCount = 0;

    async mounted() {
        await this.getRequests();
        const statData = await FactcheckRequestServices.GetPercentageOfRequestWithFactCheck();
        this.percentageOfRequestsWithFactcheck = statData.percentage
        this.requestsWithFactcheck = statData.countWithFactcheck

        const rtData = await FactcheckRequestServices.GetAverageResponseTime();
        this.averageResponseTimeMs = rtData.averageMs;
        this.averageResponseTimeCount = rtData.count;
    }

    get formattedAverageResponseTime(): string {
        if (this.averageResponseTimeMs === null) return '—';
        const start = new Date(0);
        const end = new Date(this.averageResponseTimeMs);
        const duration = intervalToDuration({ start, end });
        const parts: string[] = [];
        if (duration.years) parts.push(`${duration.years}j`);
        if (duration.months) parts.push(`${duration.months}ma`);
        if (duration.days) parts.push(`${duration.days}d`);
        if (duration.hours) parts.push(`${duration.hours}u`);
        return parts.length ? parts.join(' ') : '< 1u';
    }

    get requestSourcesPerSource() {
        return this.requests.reduce((acc, request) => {
            if (!acc[request.source]) {
                acc[request.source] = 0;
            }
            acc[request.source]++;
            return acc;
        }, {} as { [key: string]: number });
    }
}
